module.exports = __webpack_public_path__ + "img/Schrott Helmut.jpg";